import React from 'react';
import { useSelector } from 'react-redux';
import { Channel, RootState } from '../../interfaces';
import { usePlaybills } from '../../queries/playbills/queries';
import { broadcastingNow } from '../../utils/huaweiUtils';
import LiveCollageProgram from './LiveCollageProgram';
import './style.scss';
import css from './skeleton.module.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  channels: Channel[];
  channelsToUse?: string[];
  title?: string;
}

interface ChannelViewProps {
  channel: Channel;
  index: number;
}

const ChannelViewSkeleton = () => {
  return <div className={css.skeleton} />;
};

const ChannelView = ({ channel, index }: ChannelViewProps) => {
  const { data: programs, isLoading } = usePlaybills({ channelIds: [channel.contentId], date: new Date() });
  const auth = useSelector((rootState: RootState) => rootState.authReducer);

  if (isLoading) {
    return <ChannelViewSkeleton />;
  }

  if (!programs) {
    return null;
  }

  const liveProgram = programs.find(broadcastingNow);

  if (liveProgram === undefined || programs.length === 0) {
    return null;
  }

  return (
    <div className={'collage-box collage-box-' + index} key={'channel-collage-' + channel.contentId}>
      <LiveCollageProgram {...liveProgram} channel={channel} authReducer={auth} programOrder={index} />
    </div>
  );
};

export default function TVProgramCollage({ channels, title }: Props) {
  const { t } = useTranslation();
  return (
    <>
      <div className="tv-program-collage-container">
        <div className="tv-program-collage-title">
          <h1 style={{ fontSize: 20 }} title={t('live now')}>
            {title ? title : t('live now')}
          </h1>
        </div>
        <div className={'tv-program-collage'}>
          {channels?.map((channel, index) => {
            return <ChannelView channel={channel} index={index} key={index} />;
          })}
        </div>
      </div>
    </>
  );
}
